import CoppaConfirmation from './CoppaConfirmation'

export default CoppaConfirmation
